import React, { useEffect, useState } from 'react';
import { Col, Container, Form, FormControl, Nav, Row, Spinner } from 'react-bootstrap';
// import logo from './Assets/logo.png'
import changePass from './Assets/changepass.svg'
// import { Autocomplete, InputLabel, TextField } from '@mui/material';
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom';
// import { BaseIp, ChangePassApi, UserCreateApi } from './Api';
import axios from 'axios';
import { toast } from 'react-toastify';
import AdminNav from './AdminNav';
import DeliveryHeader from './Delivery/DeliveryHeader';
import { ChangePasswordApi } from './Admin/API/Api';
import AdminHeader from './Admin/AdminMaster/AdminHeader';

const ChangePassword = () => {
    const [loading, setLoading] = useState(false);
    const [oldPassword, setOldPassword] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordsMatch, setPasswordsMatch] = useState(true);
    const navigate = useNavigate();
    const userdata = JSON.parse(sessionStorage.getItem('userdata')) || {};
    let { branch_id: branchId, branch_name: Name, mrbranch_name: MarathiName } = userdata;
    const selectedLanguage = sessionStorage.getItem('selectedLanguage');
    const displayName = selectedLanguage === 'Marathi' ? MarathiName : Name;
    const email = userdata.email_id
    const BranchId = userdata.branch_id


    const input = {
      border: '1px solid',
      margin: '10px 10px 10px 0px',
    };
    
  
  
    const handlePasswordChange = (value) => {
      setPassword(value);
      setPasswordsMatch(value === confirmPassword);
    };
  
    const handleConfirmPasswordChange = (value) => {
      setConfirmPassword(value);
      setPasswordsMatch(value === password);
    };
  


    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!oldPassword || !password || !confirmPassword) {
            toast.error('Please fill in all the password fields.');
            return;
        }
    
        if (!passwordsMatch) {
            toast.error('Passwords do not match');
            return;
        }
    
        try {
            setLoading(true);
    
            const Obj = {
                email_id: email,
                password: oldPassword,
                newPassword: password,
            };
    
            console.log("Request Object:", Obj);
    
            // Make API call
            const response = await axios.put(ChangePasswordApi, Obj);
            console.log("res../...",response);
            if(response.data === "NOTFOUND"){
                toast.error('Old password does not match.');
 
            }else if (response.data === 'UPDATE') {
                // Customize the response for password updated successfully
                toast.success('Password changed successfully');
                setOldPassword('');
                setPassword('');
                setConfirmPassword('');
            } else {
                // Handle unknown response
                toast.error('Unknown response');
            }
        } catch (error) {
            // Handle errors during the API call
            toast.error('An error occurred while changing the password');
        } finally {
            setLoading(false);
        }
    };
    
    
    
      
    return (
        <Container fluid>
            <Row >
            <AdminHeader />
            </Row>

            <Container className='mb-5 mt-md-5 mt-3'>
            <Row className='pt-md-3 mt-0'>
                <Col sm={12} md={4} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img src={changePass} className='w-100' />
                </Col>
                <Col md={8} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div className='login-container mb-4 mb-md-0'>
                        <div className='login-form shadow mb-5 mb-md-3 py-3' style={{ border: "3px solid rgb(255, 93, 0)", borderRadius: "15px" }}>
                            <form
                                onSubmit={handleSubmit}
                            >
                                <div className='input'>

                                    <h2 className='text-center mb-4' style={{color:"black"}}>{selectedLanguage === 'Marathi' ? 'पासवर्ड बदला' : 'Change Password'}:</h2>

                                    <div className="col-md-12 ">
                      <Form.Group controlId="validationCustom06">
                        <label htmlFor="password" style={{color:"black"}}>{selectedLanguage === 'Marathi' ? 'जुना पासवर्ड' : 'Old Password'}:</label>
                        <FormControl
                          style={input}
                          type="password"
                          id="password"
                          value={oldPassword}
                          onChange={(e) => setOldPassword(e.target.value)}
                          required
                        />
                      </Form.Group>
                    </div>


                                    <div className="col-md-12 ">
                      <Form.Group controlId="validationCustom06">
                        <label htmlFor="password" style={{color:"black"}}>{selectedLanguage === 'Marathi' ? 'पासवर्ड तयार करा' : 'Create Password'}:</label>
                        <FormControl
                          style={input}
                          type="password"
                          id="password"
                          value={password}
                          isInvalid={!passwordsMatch}
                          onChange={(e) => handlePasswordChange(e.target.value)}
                          required
                        />
                      </Form.Group>
                    </div>


                    <div className="col-md-12">
                      <Form.Group controlId="validationCustom06">
                        <label htmlFor="confirmPassword" style={{color:"black"}}>{selectedLanguage === 'Marathi' ? 'पासवर्डची पुष्टी करा' : 'Confirm Password'}:</label>
                        <FormControl
                          style={input}
                          type="password"
                          id="confirmPassword"
                          value={confirmPassword}
                          isInvalid={!passwordsMatch}
                          onChange={(e) => handleConfirmPasswordChange(e.target.value)}
                          required
                        />
                        {/* <Form.Control.Feedback type="invalid">
                          Password do not match
                        </Form.Control.Feedback> */}
                      </Form.Group>
                    </div>

                                    <div className='login-button mt-3 mb-3'>
                                        <button type="submit" className='login-btn rounded' style={{backgroundColor:"rgb(255, 93, 0)",border:"1px solid rgb(255, 93, 0)"}}>{loading ? <Spinner animation='border' size='sm' variant="primary" /> : <b>{selectedLanguage === 'Marathi' ? 'पुष्टी' : 'Confirm'}</b>}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Col>
            </Row>
            </Container>

            <Row className='m-0 p-0 fixed-bottom   py-2' style={{ backgroundColor:"rgb(47, 79, 79)", display: "flex", justifyContent: "center", alignContent: "center", fontFamily: "monospace", color: "white" }}>
        <h6 className='text-center '>2023 DESIGN & DEVELOPED BY | TechnoAarv Solution</h6>
      </Row>
        </Container>
    )
}

export default ChangePassword
